import { Button } from "@/components/button";
import { IframeMap, PieceBanner } from "@/domains/components";
import { useGetLocation, type MapInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { CustomText, CustomTitle } from "./location.style";

export const Location = () => {
    const { data } = useGetLocation<MapInfoResponse>({ section: "location" });
    const { isMobile } = MEDIA();

    return data ? (
        <Box w="100%">
            <PieceBanner
                imgUrl={data.imgUrl}
                name={data.pensionInfo.name}
                title={{
                    main: "Location",
                    sub: "오시는 길",
                }}
            />
            <Center as="section" flexDir="column" rowGap={isMobile ? "28px" : "56px"}>
                <Center flexDir="column" rowGap={isMobile ? "32px" : "64px"}>
                    <Center flexDir="column">
                        <CustomTitle fontFamily="Cormorant">Location</CustomTitle>
                        <Text fontFamily="Cormorant">{data.pensionInfo.name.en} PENSION</Text>
                    </Center>
                    <Center flexDir="column" rowGap="8px">
                        <CustomText>도로명 : {data.pensionInfo.addressDetail.street}</CustomText>
                        <CustomText>지번 : {data.pensionInfo.addressDetail.jibun}</CustomText>
                    </Center>
                </Center>
                <IframeMap w="100%" h="470px" latLng={data.latLng} />
                <Center columnGap="16px">
                    <Button size="medium">네이버 길찾기</Button>
                    <Button size="medium">카카오 길찾기</Button>
                </Center>
            </Center>
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
